import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgCloudWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M3.924 17.376a1 1 0 0 0 1.052-.534 1.018 1.018 0 0 0-.743-1.476 2.52 2.52 0 0 1-1.594-.707A2.37 2.37 0 0 1 2 12.874a2.59 2.59 0 0 1 2.586-2.587 2.6 2.6 0 0 1 .535.056 1 1 0 0 0 .811-.186 1 1 0 0 0 .392-.779 4.52 4.52 0 0 1 .961-3.012c3.357-3.8 8.227-2.47 9.856.966a1.02 1.02 0 0 0 .978.57 3.67 3.67 0 0 1 2.721 1.05A3.76 3.76 0 0 1 22 11.679a3.9 3.9 0 0 1-2.483 3.61.97.97 0 0 0-.586 1.373.956.956 0 0 0 1.162.47 5.6 5.6 0 0 0 3.9-5.2 5.77 5.77 0 0 0-5.215-6.007.25.25 0 0 1-.191-.12 7.685 7.685 0 0 0-14.1 2.3.25.25 0 0 1-.227.2 4.64 4.64 0 0 0-3.64 2.242A4.5 4.5 0 0 0 0 12.994a4.29 4.29 0 0 0 1.235 3.09 5.06 5.06 0 0 0 2.689 1.292"
      fill="currentColor"
    />
    <path
      d="M13.281 10.2a1.45 1.45 0 0 0-2.562 0l-5.056 9.634a1.43 1.43 0 0 0 .049 1.408 1.45 1.45 0 0 0 1.233.687h10.111a1.46 1.46 0 0 0 1.233-.687 1.43 1.43 0 0 0 .048-1.408ZM12 20.179a1 1 0 1 1 1-1 1 1 0 0 1-1 1m-.75-6.75a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0Z"
      fill="currentColor"
    />
  </svg>
);
